exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".albumslist-component .albums{position:relative}.albumslist-component .albums .title{font-size:18px;padding-left:20px;padding-right:20px;padding-top:27px;margin-bottom:18px;color:#333;display:block}.albumslist-component .albums .albums-pics{min-height:90px}.albumslist-component .albums .albums-pics .small-4{float:left}.albumslist-component .albums .albums-img{border-radius:10px;margin-bottom:10px}.albumslist-component .albums .albums-count{width:40px;height:40px;border-radius:5px;color:#aaa;font-size:30px;line-height:40px;text-align:center;background-color:#ebe7e7;margin:0 auto}.albumslist-component .albums .albums-more{color:#999;bottom:10px;width:25%;text-align:center;margin:0 auto;position:absolute}.albumslist-component .albums .top-tag{width:36px;background:green;font-size:12px;color:#fff;text-align:center;padding:2px 5px;border-radius:3px;margin:10px auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/AlbumsList.scss
// module id = 623
// module chunks = 0